<template>
    <div style="position: relative; display: inline-block;">
        <div class="reportrange-text" @click="togglePicker" v-if="!showCalendar" style="padding: 6px 15px;">
            <slot name="input">
                <i class="glyphicon glyphicon-calendar far fa-calendar-alt"></i>
                <span style="font-size: 14px; font-weight: 400; color: #495057;">{{startText}} - {{endText}}</span>
                <b class="caret"></b>
            </slot>
        </div>
        <transition name="slide-fade" mode="out-in">
            <div class="daterangepicker dropdown-menu ltr" :class="pickerStyles()" v-if="open || showCalendar"
                 v-on-clickaway="clickAway">

                <div class="calendar left">
                    <!-- <div class="daterangepicker_input hidden-xs">
                        <input class="input-mini form-control" type="text" name="daterangepicker_start"
                               :value="startText"/>
                        <i class="far fa-calendar-alt glyphicon glyphicon-calendar"></i>
                    </div> -->
                    <div class="calendar-table">
                        <calendar ref="leftCal" :clickedDate="clickedDate" :clearToolTip="clearToolTip" :monthDate="monthDate"
                                  :locale="locale"
                                  :start="start" :end="end" :active="active"
                                  :disablePrevDates="disablePrevDates"
                                  :availableDates="availableDates"
                                  :maxDate="maxDate"
                                  :showPrice="showPrice"
                                  :priceSymbol="priceSymbol"
                                  :disabledDates="disabledDates"
                                  :isCustomCalendar="isCustomCalendar"
                                  :canSelect="in_selection"
                                  @nextMonth="nextMonth" @prevMonth="prevMonth"
                                  @dateClick="dateClick" @hoverDate="hoverDate"
                        ></calendar>
                    </div>
                </div>

                <div class="calendar right hidden-xs">
                    <!-- <div class="daterangepicker_input">
                        <input class="input-mini form-control" type="text" name="daterangepicker_end"
                               :value="endText"/>
                        <i class="far fa-calendar-alt glyphicon glyphicon-calendar"></i>
                    </div> -->
                    <div class="calendar-table">
                        <calendar ref="rightCal" :clickedDate="clickedDate" :clearToolTip="clearToolTip" :monthDate="nextMonthDate"
                                  :locale="locale"
                                  :start="start" :end="end" :active="active"
                                  :availableDates="availableDates"
                                  :maxDate="maxDate"
                                  :showPrice="showPrice"
                                  :priceSymbol="priceSymbol"
                                  :disabledDates="disabledDates"
                                  :disablePrevDates="disablePrevDates"
                                  :isCustomCalendar="isCustomCalendar"
                                  :canSelect="in_selection"
                                  @nextMonth="nextMonth" @prevMonth="prevMonth"
                                  @dateClick="dateClick" @hoverDate="hoverDate"
                        ></calendar>
                    </div>
                </div>

                <calendar-ranges :canSelect="in_selection" @clickCancel="open=false" @clickRange="clickRange"
                                 @clickApply="clickedApply" :ranges="ranges" class=" hidden-xs">
                </calendar-ranges>
                <div class="calendarClearDates" v-if="isCustomCalendar">
                  <button type="button" @click="clearDates()">Clear dates</button>
                </div>
            </div>
        </transition>
    </div>
</template>
<style>
@import "./DateRangePicker.css";
</style>
<script>
import moment from "moment";
import Calendar from "./Calendar.vue";
import CalendarRanges from "./CalendarRanges";
import { nextMonth, prevMonth } from "./util";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "date-range-picker",
  components: { Calendar, CalendarRanges },
  mixins: [clickaway],
  props: {
    isCustomCalendar: {
      type: Boolean,
      default() {
        return false;
      }
    },
    maxDate: {
      type: String,
      default() {
        return ""
      }
    },
    minDate: {
      type: String,
      default() {
        return ""
      }
    },
    showCalendar: {
      type: Boolean,
      default() {
        return false
      }
    },
    availableDates: {
      type: Array,
      default() {
        return []
      }
    },
    showPrice: Boolean,
    priceSymbol: {
      type: String,
      default() {
        return ""
      }
    },
    disabledDates: {
      type: Array,
      default() {
        return []
      }
    },
    disablePrevDates: Boolean,
    updateDate: {},
    localeData: {
      type: Object,
      default() {
        return {};
      }
    },
    startDate: {
      default() {
        return new Date();
      }
    },
    endDate: {
      default() {
        return new Date();
      }
    },
    ranges: {
      type: Object,
      default() {
        return {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days")
          ],
          "This month": [moment().startOf("month"), moment().endOf("month")],
          "This year": [moment().startOf("year"), moment().endOf("year")],
          "Last week": [
            moment()
              .subtract(1, "week")
              .startOf("week"),
            moment()
              .subtract(1, "week")
              .endOf("week")
          ],
          "Last month": [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month")
          ]
        };
      }
    },
    opens: {
      type: String,
      default: "center"
    }
  },
  data() {
    let default_locale = {
      direction: "ltr",
      format: moment.localeData().longDateFormat("L"),
      separator: " - ",
      applyLabel: "Apply",
      cancelLabel: "Cancel",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.months(),
      firstDay: moment.localeData().firstDayOfWeek()
    };

    // let data = { locale: _locale }
    let data = { locale: { ...default_locale, ...this.localeData } };

    if (this.startDate == null) {
      data.monthDate = new Date();
    } else {
      data.monthDate = new Date(this.startDate);
    }
    data.clickedDate = null;
    data.start = null;
    data.end = null;
    data.in_selection = false;
    data.open = false;
    data.active = null;

    // update day names order to firstDay
    if (data.locale.firstDay !== 0) {
      let iterator = data.locale.firstDay;
      while (iterator > 0) {
        data.locale.daysOfWeek.push(data.locale.daysOfWeek.shift());
        iterator--;
      }
    }
    return data;
  },
  methods: {
    clearCSSClasses() {
      this.$refs.leftCal.tooltipText = "";
      this.$refs.leftCal.selectedDate = null;
      this.$refs.rightCal.tooltipText = "";
      this.$refs.rightCal.selectedDate = null;
      $(".be-no-check-out").removeClass("be-no-check-out");
      $(".be-no-check-in").removeClass("be-no-check-in");
      $(".noCheckInCheckOut").removeClass("noCheckInCheckOut");
      $(".min-stay-restriction-before-disable-date").removeClass("min-stay-restriction-before-disable-date");
    },
    clearToolTip() {
      if (this.$refs.leftCal.tooltipText != "Checkout day") {
        this.$refs.leftCal.tooltipText = "";
        this.$refs.leftCal.selectedDate = null;
      }
      
      // this.$refs.rightCal.tooltipText = "";
      // this.$refs.rightCal.selectedDate = null;
    },
    clearDates() {
      this.in_selection = false;
      this.$emit("clearAllSelectedDates");
      this.clearCSSClasses();
      this.$refs.rightCal.tooltipText = "";
      this.$refs.rightCal.selectedDate = null;
      this.$refs.leftCal.tooltipText = "";
      this.$refs.leftCal.selectedDate = null;
      this.clickedDate = null;
    },
    nextMonth() {
      this.monthDate = nextMonth(this.monthDate);
      this.clearCSSClasses();
      if (this.start == undefined) {
        this.clickedDate = null;
      }
      this.$emit("updateDisablePrevDates", false);
    },
    prevMonth() {
      this.monthDate = prevMonth(this.monthDate);
      this.clearCSSClasses();
      if (this.start == undefined) {
        this.clickedDate = null;
      }
      if (this.monthDate.getMonth() == new Date().getMonth() && this.monthDate.getFullYear() == new Date().getFullYear()) {
          this.$emit("updateDisablePrevDates", true);
      } else {
        this.$emit("updateDisablePrevDates", false);
      }
    },
    dateClick(value) {
      var vm = this;
      // this.$refs.leftCal.tooltipText = "";
      // this.$refs.rightCal.tooltipText = "";
      var availableDate = this.availableDates.filter(function(availability) {
          return availability.date ==  moment(value).format("YYYY-MM-DD");
      });
      if (this.isCustomCalendar) {
        if (this.start && this.end && (moment(value).format("YYYY-MM-DD") < moment(new Date()).format("YYYY-MM-DD") || availableDate[0] == undefined)
          && moment(this.start).format("YYYY-MM-DD") != moment(this.end).format("YYYY-MM-DD")) {
          return
        }
        if (availableDate[0] == undefined) {
          return
        }
        
        if (availableDate[0].nocheckin && availableDate[0].nocheckout) {
          // this.clearCSSClasses();
          // this.$refs.leftCal.tooltipText = "";
          // this.$refs.rightCal.tooltipText = "";
          var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= moment(this.start).format("YYYY-MM-DD") && date.manuallyEnabledDate);
          
          var nextDisableDates = this.disabledDates.filter((date) => date >= moment(this.start).format("YYYY-MM-DD"));
          if (this.start && nextDisableDates.length > 0) {
            let selectedEndDate = moment(value, "YYYY-MM-DD");
            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");

            let nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");

            if(nextManuallyEnabledDate < nextDisableDate){
              nextDisableDate = nextManuallyEnabledDate;
            }
            if (selectedEndDate >= nextDisableDate) {
              return;
            }
          }
          if (this.start && new Date(value).setHours(0,0,0,0) < new Date(this.start).setHours(0,0,0,0)) {
            return;
          }
          $(event.target.closest("td")).addClass("noCheckInCheckOut");
          this.clickedDate = new Date(value);
          // if (this.start && new Date(value).setHours(0,0,0,0) < new Date(this.start).setHours(0,0,0,0)) {
          //   $(".noCheckInCheckOut").removeClass("noCheckInCheckOut");
          //   this.clickedDate = null;
          // }
        }
        if (availableDate[0].nocheckin == true  && !this.in_selection) {
          this.start = null;
          this.active = null;
          this.end = null;
          this.$emit("update", { startDate: this.start, endDate: this.end });
          var evt = event;
          setTimeout(() => {
            vm.clearCSSClasses();
            this.$refs.leftCal.tooltipText = "";
            this.$refs.rightCal.tooltipText = "";
            $(evt.target.closest("td")).addClass("be-no-check-in");
          }, 10)
          return;
        }
        if (availableDate[0].nocheckout == true  && this.in_selection) {
          var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= moment(this.start).format("YYYY-MM-DD") && date.manuallyEnabledDate);
          var nextDisableDates = this.disabledDates.filter((date) => date >= moment(this.start).format("YYYY-MM-DD"));
          if (this.start && nextDisableDates.length > 0) {
            let nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");

            let selectedEndDate = moment(value, "YYYY-MM-DD");
            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
            if(nextManuallyEnabledDate < nextDisableDate){
              nextDisableDate = nextManuallyEnabledDate;
            }
            if (selectedEndDate >= nextDisableDate) {
              return;
            }
          }
          var evt = event;
          setTimeout(() => {
            if (this.start && new Date(value).setHours(0,0,0,0) > new Date(this.start).setHours(0,0,0,0)) {
              this.clickedDate =  new Date(value);
            }
          }, 10)
          return;
        }
      }
      if (new Date(value).setHours(0,0,0,0) < new Date().setHours(0,0,0,0) 
      || (this.start && (this.end == undefined || this.start.setHours(0,0,0,0) == this.end.setHours(0,0,0,0)) && new Date(value).setHours(0,0,0,0) < this.start.setHours(0,0,0,0))) {
        return;
      }
      if (this.in_selection) {
        var checkInElement = $(".check-in");
        if (this.isCustomCalendar) {
          var startDate = this.start;
          var selectedStartDate = this.availableDates.filter(function(availability) {
              return moment(availability.date).format("YYYY-MM-DD") == moment(startDate).format("YYYY-MM-DD");
          });
          if (selectedStartDate[0] != undefined) {
            let minNightDate = moment(selectedStartDate[0].date, "YYYY-MM-DD").add("days", selectedStartDate[0].min_night_stay);
            if (new Date(minNightDate).setHours(0,0,0,0) > new Date(value).setHours(0,0,0,0)) {
              $(".in-range-min-stay-restriction").removeClass("in-range-min-stay-restriction");
              var evt = event;
              setTimeout(() => {
                if (new Date(value).setHours(0,0,0,0) != new Date(selectedStartDate[0].date).setHours(0,0,0,0)) {
                  $(evt.target.closest("td")).addClass("in-range-min-stay-restriction").removeClass("active in-range");
                }
              }, 50)
              this.clickedDate = null;
              return;
            }
            $(".in-range-min-stay-restriction").removeClass("in-range-min-stay-restriction");
          }
          var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= moment(startDate).format("YYYY-MM-DD") && date.manuallyEnabledDate);
          var nextDisableDates = this.disabledDates.filter((date) => date >= moment(startDate).format("YYYY-MM-DD"));
          if (nextDisableDates.length > 0) {
            let selectedEndDate = moment(value, "YYYY-MM-DD");
            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
            let nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");

            if(nextManuallyEnabledDate < nextDisableDate){
              nextDisableDate = nextManuallyEnabledDate;
            }
            if (selectedEndDate >= nextDisableDate) {
              $(".noCheckInCheckOut").removeClass("noCheckInCheckOut");
              // this.clickedDate = null;
              return;
            }
          }
          if (availableDate[0].nocheckout == true) {
            var evt = event;
            setTimeout(() => {
              if (new Date(value).setHours(0,0,0,0) != this.start.setHours(0,0,0,0)) {
                vm.clearCSSClasses();
                this.$refs.leftCal.tooltipText = "";
                this.$refs.rightCal.tooltipText = "";
                $(evt.target.closest("td")).addClass("be-no-check-out");
                this.clickedDate = new Date(value);
              }
            }, 50)
            $(".be-no-check-out").removeClass("active in-range");
            return;
          }
        }
        this.in_selection = false;
        this.end = new Date(value);
        this.active = new Date(value);
        if (this.end < this.start) {
          this.in_selection = true;
          this.start = new Date(value);
          // this.open = false;
        }
        else{
          this.open = false;
        }
        this.$emit("availability");
        this.$emit("update", { startDate: this.start, endDate: this.end });
        var evt = event;
        setTimeout(() => {
          $(evt.target.closest("td")).addClass("check-out");
          checkInElement.addClass("check-in");
        }, 60);
        this.clickedDate = null;
      } else {
        if (this.isCustomCalendar) {
          var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= moment(value).format("YYYY-MM-DD") && date.manuallyEnabledDate);
          var nextDisableDates = this.disabledDates.filter((date) => date >= moment(value).format("YYYY-MM-DD"));
          var minNightDate = moment(availableDate[0].date, "YYYY-MM-DD").add("days", availableDate[0].min_night_stay);
          var minNightDateObj = this.getAvailableDateObj(minNightDate);
          var notEligible = false;
          if (minNightDateObj[0] != undefined && minNightDateObj[0].nocheckout) {
            notEligible = true;
            if (nextDisableDates.length > 0) {

              var nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
              var nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");

              if(nextManuallyEnabledDate < nextDisableDate){
                nextDisableDate = nextManuallyEnabledDate;
              }
              var tempMinNightDate = minNightDate;
              while (new Date(tempMinNightDate).setHours(0,0,0,0) != new Date(nextDisableDate).setHours(0,0,0,0)) {
                var nextDate = moment(tempMinNightDate, "YYYY-MM-DD").add("days", 1);
                var nextDateObj = this.getAvailableDateObj(nextDate);
                if (nextDateObj[0] != undefined && !nextDateObj[0].nocheckout) {
                  notEligible = false;
                  break;
                }
                tempMinNightDate = nextDate;
              }
              if (notEligible) {
                this.clearCSSClasses();
                $(event.target.closest("td")).addClass("min-stay-restriction-before-disable-date").removeClass("active in-range");
                return
              }
            }
            
          }
          if (nextDisableDates.length > 0) {
            //let minNightDate = moment(availableDate[0].date, "YYYY-MM-DD").add("days", availableDate[0].min_night_stay);
            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
            let nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");

              if(nextManuallyEnabledDate < nextDisableDate){
                nextDisableDate = nextManuallyEnabledDate;
              }
            if (minNightDate >= nextDisableDate) {
              this.start = null;
              this.active = null;
              this.end = null;
              this.$emit("update", { startDate: this.start, endDate: this.end });
              var evt = event;
              setTimeout(() => {
                vm.clearCSSClasses();
                $(evt.target.closest("td")).addClass("min-stay-restriction-before-disable-date").removeClass("active in-range");
              }, 10);
              
              return;
            } else if (minNightDate > new Date(value).setHours(0,0,0,0)) {
              this.end = null;
            }
            // this.clearCSSClasses();
            $(".min-stay-restriction-before-disable-date").removeClass("min-stay-restriction-before-disable-date");

          }
          this.clearCSSClasses();
          this.active = new Date(value);
          this.clickedDate = null;
        }
        this.in_selection = true;
        this.start = new Date(value);
        this.end = new Date(value);
        this.$emit("update", { startDate: this.start, endDate: this.end });
        var evt = event
        setTimeout(() => {
          $(evt.target.closest("td")).addClass("check-in");
        }, 60);
      }
    },
    getAvailableDateObj(minNightDate) {
      return this.availableDates.filter(function(availability) {
        return new Date(availability.date).setHours(0,0,0,0) == new Date(minNightDate).setHours(0,0,0,0);
      });
    },
    hoverDate(value) {
      let dt = new Date(value);
      if (this.in_selection && dt > this.start) {
        if (this.isCustomCalendar) {
          var startDate = this.start;

          var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= moment(startDate).format("YYYY-MM-DD") && date.manuallyEnabledDate);

          var nextDisableDates = this.disabledDates.filter((date) => date >= moment(startDate).format("YYYY-MM-DD"));
          if (nextDisableDates.length > 0) {
            let selectedEndDate = moment(value, "YYYY-MM-DD");
            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
            let nextManuallyEnabledDate = moment(manuallyEnabledDates[0].date, "YYYY-MM-DD").add(1,"days");
            if(nextManuallyEnabledDate < nextDisableDate){
              nextDisableDate = nextManuallyEnabledDate;
            }
            if (selectedEndDate >= nextDisableDate) {
              return;
            }
          }
          this.active = dt;
          // let availableDate = this.availableDates.filter(function(availability) {
          //     return new Date(availability.date).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
          // });
          // if (availableDate[0] !=undefined && availableDate[0].nocheckin && availableDate[0].nocheckout) {

          // }
          // var vm = this;
          // setTimeout(() => {
          //   if (vm.clickedDate != undefined && vm.clickedDate != null) {
          //     $(vm.clickedDate.target.closest("td")).addClass("noCheckInCheckOut");
          //   }
          // }, 10)

        } else {
          this.end = dt;
        }
        // this.end = dt;
        //this.$emit("update", { startDate: this.start, endDate: this.end });
      }
    },
    togglePicker() {
      this.open = !this.open;
    },
    pickerStyles() {
      return {
        "show-calendar": this.open || this.showCalendar,
        opensright: this.opens === "right",
        opensleft: this.opens === "left",
        openscenter: this.opens === "center",
        "show-availbilityCalendar": this.showCalendar
      };
    },
    clickedApply() {
      this.open = false;
      this.$emit("update", { startDate: this.start, endDate: this.end });
    },
    clickAway() {
      if (this.open) {
        this.open = false;
      }
    },
    clickRange(value) {
      this.start = new Date(value[0]);
      this.end = new Date(value[1]);
      this.active = new Date(value[1]);
      this.monthDate = new Date(value[0]);
      this.open = false;
      this.clickedApply();
    },
    setCustomDates(){
      if(this.startDate == null){
        this.start = null
      }
      else{
        this.start = new Date(this.startDate);
      }

      if(this.endDate == null){
        this.end = null
        this.active = null;
      }
      else{
        this.end = new Date(this.endDate);
        this.active = new Date(this.endDate);
      }
    },
    handleMinDateChange(newValue, oldValue) {
      console.log('Data changed:', newValue);
      this.monthDate = new Date(newValue)
      if (this.monthDate.getMonth() == new Date().getMonth()+1 && this.monthDate.getFullYear() == new Date().getFullYear()) {
          this.$emit("updateDisablePrevDates", false);
      } else {
        this.$emit("updateDisablePrevDates", true);
      }
    },
  },
  computed: {
    nextMonthDate() {
      return nextMonth(this.monthDate);
    },
    startText() {
      console.log("startText", this.start)
      if(this.start == null){
        this.$emit("startAndEndTexts", {isTrueOrFalse : true});
        return "Check In"
        
      }
      else{
        this.$emit("startAndEndTexts", {isTrueOrFalse : false});
        return moment(this.start).format("DD MMM YYYY"); //toLocaleDateString();
        
      }
      
    },
    endText() {
      // this.open = false;
      if(this.end == null){
        return "Check Out"
      }
      else{
        return moment(this.end).format("DD MMM YYYY"); //.toLocaleDateString();

      }
      
    }
  },
  watch: {
    startDate(value) {
      this.setCustomDates()
    },
    endDate(value) {
      this.setCustomDates()
    },
    updateDate(value) {
      this.setCustomDates()
    },

  },
    created() {
    this.$watch('minDate', this.handleMinDateChange);
  },
  mounted(){
    // this.setCustomDates()
  }
};
</script>

<style>
.range_inputs {
  margin-bottom: 10px;
}

.reportrange-text {
  background: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #ccc;
  width: 100%;
}

.daterangepicker.show-calendar {
  display: inline-flex;
}

.daterangepicker .ranges {
  width: 160px;
}

.ranges {
  width: 130px;
}

.show-calendar {
  display: block;
  width: auto;
}

div.daterangepicker.opensleft {
  top: 35px;
  right: 10px;
  left: auto;
}

div.daterangepicker.openscenter {
  top: 35px;
  right: auto;
  left: 50%;
  transform: translate(-50%, 0);
}

div.daterangepicker.opensright {
  top: 35px;
  left: 10px;
  right: auto;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */
 {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DateRangePicker/components/DateRangePicker.vue